module.exports = __webpack_public_path__ + "img/online-work.075cf5bf.png";